import styled from 'styled-components'

import type { components } from '../../constants/schema'

import { Wrap } from '../../components/container/Wrap'
import { Content } from '../../components/container/Content'
import { ArtipioContents, ArtipioContentItem } from '../../components/contents'

import image1 from '../../assets/terms/personalInfoProcessingPolicy/개인정보 수집항목1.png'
import image2 from '../../assets/terms/personalInfoProcessingPolicy/거주지 확인을 위해 수집되는 정보.png'
import image3 from '../../assets/terms/personalInfoProcessingPolicy/개인정보 수집항목 2.png'
import image4 from '../../assets/terms/personalInfoProcessingPolicy/마케팅 및 광고에의 활용.png'
import image5 from '../../assets/terms/personalInfoProcessingPolicy/앱을 통해 수집되는 정보.png'
import image6 from '../../assets/terms/personalInfoProcessingPolicy/자동으로 생성되어 수집되는 정보.png'
import image7 from '../../assets/terms/personalInfoProcessingPolicy/이용자의 별도 동의가 있는 경우 수집되는 정보.png'
import image8 from '../../assets/terms/personalInfoProcessingPolicy/제5조 개인정보 처리, 보유 및 이용기간 .png'
import image9 from '../../assets/terms/personalInfoProcessingPolicy/개인정보처리의 위탁.png'
import image10 from '../../assets/terms/personalInfoProcessingPolicy/개인정보의 제3자 제공.png'
import image11 from '../../assets/terms/personalInfoProcessingPolicy/개인정보의 제3자 제공2.png'
// import image12 from '../../assets/terms/personalInfoProcessingPolicy/회사가 해산, 영업정지, 부도발생, 파산 또는 회생절차 개시 기타.png'
import image13 from '../../assets/terms/personalInfoProcessingPolicy/개인정보보호책임자 .png'

const TERMS_DATA: components['schemas']['MarkdownContent'][] = [
  {
    type: 'heading2',
    content: '개인정보처리방침',
    prop: {
      align: 'left',
      color: 'text_primary',
    },
  },
  {
    type: 'body',
    content:
      '주식회사 아티피오(ARTiPIO)(이하 “회사”라고 함)는 이용자의 개인정보를 매우 소중하게 다루고 있습니다. 회사는 개인정보 보호와 관련된 법규를 준수하며 이용자의 개인정보가 보호받을 수 있도록 최선을 다하고 있습니다. 본 개인정보처리방침을 통하여 이용자가 제공한 개인정보가 어떠한 용도와 방식으로 이용되며, 개인정보 보호를 위하여 어떠한 조치가 취해지고 있는지 알려드립니다.',
    prop: {
      align: 'left',
      color: 'text_primary',
    },
  },
  {
    type: 'body',
    content:
      '본 개인정보처리방침은 개인정보보호와 관련한 법률 또는 지침의 변경, 회사 정책의 변화에 따라 변경될 수 있으며, 변경 시 공지사항(또는 개별공지)을 통하여 공지할 것입니다. 이용자께서는 수시로 확인하시기 바랍니다.',
    prop: {
      align: 'left',
      color: 'text_primary',
    },
  },
  {
    type: 'heading3',
    content: '제1조 개인정보의 처리 목적',
    prop: {
      align: 'left',
      color: 'text_primary',
    },
  },
  {
    type: 'body',
    content:
      '“개인정보”라 함은 생존하는 개인에 관한 정보로서 당해 정보에 포함되어 있는 성명, 주민등록번호 등의 사항에 의하여 당해 개인을 식별할 수 있는 정보(당해 정보만으로는 특정 개인을 식별할 수 없더라도 다른 정보와 용이하게 결합하여 식별할 수 있는 것을 포함)를 말합니다. 개인정보 수집은 회사 서비스를 이용하고자 하는 이용자의 의사를 확인하며, 최적의 서비스를 제공하고자 하는 것입니다. 회사는 이용자의 개인정보를 다음 각 호의 목적을 위해 처리합니다. 처리한 개인정보는 다음의 목적 이외의 용도로는 사용되지 않으며 이용 목적이 변경될 시에는 사전동의를 구할 예정입니다.',
    prop: {
      align: 'left',
      color: 'text_primary',
    },
  },
  {
    type: 'bullet',
    content:
      '1. 회원가입 및 관리\n회원제 서비스 이용에 따른 본인 확인, 개인식별, 회원자격 유지 및 관리, 서비스 부정이용 방지와 비인가 사용방지, 중복가입방지, 가입의사 확인, 사고조사, 각종 고지 및 통지, 고충처리, 분쟁 해결 및 이를 위한 기록 보존 등을 위한 목적으로 개인정보를 처리합니다. 만 14세 미만 아동의 개인정보 수집 시, 법정 대리인 동의여부 확인, 추후 법정대리인 본인확인과 관련된 개인정보도 처리합니다. \n2. 민원사무 처리\n민원인의 신원 확인, 민원사항 확인, 사실조사를 위한 연락·통지, 처리결과 통보 등을 목적으로 개인정보를 처리합니다.\n3. 재화 또는 용역(서비스)의 제공\n재화 또는 서비스 제공, 콘텐츠 제공, 맞춤 서비스 제공 및 이와 관련한 대금/수수료 결제·정산 등의 목적으로 본인 인증하는 경우 개인정보를 처리합니다.\n4. 서비스 이용자의 본인확인 및 회원정보 변경 업무 처리\n본인 인증, 계좌 인증, 점유 인증, 연령 인증 등을 목적으로 개인정보를 처리합니다.\n5. 마케팅 및 광고에의 활용\n신규 서비스 개발 및 맞춤 서비스 제공, 이벤트 및 광고성 정보 제공 및 참여기회 제공, 인구통계학적 특성에 따른 서비스 제공 및 광고 게재, 서비스의 유효성 확인, 접속빈도 파악 또는 회원의 서비스 이용에 대한 통계작성 등을 목적으로 개인정보를 처리합니다.\n6. 대한민국 또는 대한민국 외의 법령상 의무 이행 등을 위한 자료 제공\n검찰/경찰 등 범죄 수사, 피해 신고에 따른 자료 제공, 과세 법률 준수 및 과세 당국의 과세자료 제공, 제세 공과금 처리 등을 목적으로 개인정보를 처리합니다.',
    prop: {
      align: 'left',
      color: 'text_primary',
    },
  },
  {
    type: 'heading3',
    content: '제2조 개인정보 수집 및 이용에 대한 동의',
    prop: {
      align: 'left',
      color: 'text_primary',
    },
  },
  {
    type: 'bullet',
    content:
      '① 회사는 회원 가입시 ‘서비스 이용약관’과 ‘개인정보 수집 및 이용’에 동의하는 절차를 마련하고 있습니다.\n② 회원은 위 절차에 동의하지 아니할 수 있으나, 동의의 의사표시가 없으면 회원으로 가입하거나 회사의 서비스를 이용하실 수 없습니다.',
    prop: {
      align: 'left',
      color: 'text_primary',
    },
  },
  {
    type: 'heading3',
    content: '제3조 개인정보 수집항목',
    prop: {
      align: 'left',
      color: 'text_primary',
    },
  },
  {
    type: 'body',
    content: '회사가 수집하는 개인정보 항목은 다음과 같습니다.',
    prop: {
      align: 'left',
      color: 'text_primary',
    },
  },
  {
    type: 'bullet',
    content:
      '1. 회원 가입, 원활한 고객상담 등 각종 서비스의 제공을 위해 이용자의 별도 동의를 거쳐 수집하는 개인정보의 필수 항목',
    prop: {
      align: 'left',
      color: 'text_primary',
    },
  },
  {
    type: 'image',
    content: image1,
    prop: {
      shrinkPadding: true,
    },
  },
  {
    type: 'bullet',
    content: '2. 거주지 확인을 위해 수집되는 정보',
    prop: {
      align: 'left',
      color: 'text_primary',
    },
  },
  {
    type: 'image',
    content: image2,
    prop: {
      shrinkPadding: true,
    },
  },
  {
    type: 'bullet',
    content:
      '3. 투자계약 관련 서비스 제공이나 업무 처리(투자계약증권 청약 또는 철회, 투자계약 체결 내역 및 투자정보 조회, 청산금 지급, 원천징수 등)를 위해 수집되는 정보',
    prop: {
      align: 'left',
      color: 'text_primary',
    },
  },
  {
    type: 'image',
    content: image3,
    prop: {
      shrinkPadding: true,
    },
  },
  {
    type: 'bullet',
    content: '4. 마케팅 및 광고에의 활용',
    prop: {
      align: 'left',
      color: 'text_primary',
    },
  },
  {
    type: 'body',
    content:
      '신규 서비스 개발 및 맞춤 서비스(상품 정보 제공 등 마케팅 관련) 제공, 각종 소식 및 고지 사항 전달, 이벤트 및 광고성 정보 제공 및 참여기회 제공, 서비스의 유효성 확인, 접속빈도 파악 또는 회원의 서비스 이용에 대한 통계 등을 목적으로 수집되는 정보',
    prop: {
      align: 'left',
      color: 'text_primary',
    },
  },
  {
    type: 'image',
    content: image4,
    prop: {
      shrinkPadding: true,
    },
  },
  {
    type: 'bullet',
    content: '5. 앱을 통해 수집되는 정보',
    prop: {
      align: 'left',
      color: 'text_primary',
    },
  },
  {
    type: 'image',
    content: image5,
    prop: {
      shrinkPadding: true,
    },
  },
  {
    type: 'caption',
    content:
      '* 모바일 앱 버전에 따라 USIM 인증 시 국가 코드(MCC), 네트워크 코드(MNC), 유심 ID(UICC ID)가 추가 수집될 수 있습니다.',
    prop: {
      align: 'left',
      color: 'text_primary',
    },
  },
  {
    type: 'bullet',
    content: '6. 서비스 이용 및 처리 과정에서 자동으로 생성되어 수집되는 정보',
    prop: {
      align: 'left',
      color: 'text_primary',
    },
  },
  {
    type: 'image',
    content: image6,
    prop: {
      shrinkPadding: true,
    },
  },
  {
    type: 'caption',
    content:
      '* 이용자는 회사가 제공하는 개인 맞춤형 상품 추천 서비스를 수신 거부하거나 기타 개인 맞춤 서비스를 웹 브라우저 또는 휴대폰 단말기 설정을 통해 차단할 수 있는 선택권을 행사할 수 있습니다.',
    prop: {
      align: 'left',
      color: 'text_primary',
    },
  },
  {
    type: 'bullet',
    content: '7. 서비스 이용 과정에서 이용자의 별도 동의가 있는 경우 수집되는 정보',
    prop: {
      align: 'left',
      color: 'text_primary',
    },
  },
  {
    type: 'image',
    content: image7,
    prop: {
      shrinkPadding: true,
    },
  },
  {
    type: 'heading3',
    content: '제4조 개인정보의 수집 방법',
    prop: {
      align: 'left',
      color: 'text_primary',
    },
  },
  {
    type: 'body',
    content: '회사는 다음과 같은 방법으로 개인정보를 수집합니다.',
    prop: {
      align: 'left',
      color: 'text_primary',
    },
  },
  {
    type: 'bullet',
    content:
      '1. 최초 회원가입 또는 서비스 이용 시 \n2. 유/무선 홈페이지 및 어플리케이션, 서면 양식, 이메일 주소, 전화, 경품 행사 응모 \n3. 제휴사의 제공 \n4. 생성 정보 수집 툴을 통한 수집 \n5. 본인 확인 등 이용자의 신청에 따른 제공',
    prop: {
      align: 'left',
      color: 'text_primary',
    },
  },
  {
    type: 'heading3',
    content: '제5조 개인정보 처리, 보유 및 이용기간',
    prop: {
      align: 'left',
      color: 'text_primary',
    },
  },
  {
    type: 'bullet',
    content:
      '① 회사는 이용자의 개인정보 수집 및 이용 동의 또는 관련 법령에 정한 바에 따라 이용자의 개인정보를 처리, 보유하고 이용합니다.  \n② 본 개인정보처리방침에 별도로 보유 및 이용기간을 정하지 아니한 개인정보의 보유 및 이용기간은 다음과 같습니다. 다만, 관련 법령상 정한 날짜나 기한의 만료일이 하기에 각 정한 시점보다 나중에 도래하는 경우에는 관련 법령에 정한 날까지로 하며, 회사의 약관에 따른 회원의 부정 이용 기록 또는 부정 이용이 의심되는 기록이 있는 경우에는 하기 규정에도 불구하고, 수집 시점으로부터 5년간 보관하고 파기합니다.\n1. 이용자가 회원 탈퇴 요청을 한 경우, 회원 탈퇴가 완료될 때까지\n2. 이용자가 개인정보 이용 등에 대한 동의를 철회한 경우, 해당 동의 철회의 의사표시가 회사에 도달한 때까지. 단, 이용자가 동의 철회 당시 투자계약증권 또는 예치금 보유 시에는 청산금 지급, 예치금 환불 등 관련 업무를 처리하기 위한 범위 내에서는 예외로 한다. \n3. 개인정보 수집 목적을 달성한 경우, 수집 목적 달성으로 인해 해당 정보가 불필요하게 되었을 때까지\n③ 하기 법령을 포함하여 관련 법령에 의하여 보관하여야 하는 개인정보는 해당 법령이 정한 기간 동안 보관됩니다. 만약 향후 신규 법령이 제정되거나 하기 법령이 개정되는 경우, 제∙개정된 바에 의합니다.',
    prop: {
      align: 'left',
      color: 'text_primary',
    },
  },
  {
    type: 'image',
    content: image8,
    prop: {
      shrinkPadding: true,
    },
  },
  {
    type: 'bullet',
    content:
      '④ 이용자의 개인정보는 회원 탈퇴 시 또는 제공 목적 달성 후 별도의 DB로 옮겨져 내부 방침 및 기타 관련 법령에 의한 정보보호 사유에 따라 일정 기간 보관된 후 기록을 재생할 수 없는 기술적 방법에 의하여 영구 삭제됩니다. 별도 DB로 옮겨진 개인정보는 법률에 의한 경우가 아니고서는 보유 이외의 다른 목적으로 이용되지 않습니다.',
    prop: {
      align: 'left',
      color: 'text_primary',
    },
  },
  {
    type: 'heading3',
    content: '제6조 개인정보처리의 위탁',
    prop: {
      align: 'left',
      color: 'text_primary',
    },
  },
  {
    type: 'bullet',
    content:
      '① 회사는 원활한 개인정보 업무 처리를 위하여 다음과 같이 개인정보 처리 업무를 위탁하고 있으며, 보유 및 이용기간은 회원 탈퇴 및 위탁 계약 만료 시까지이며, 업체가 관련 법령을 위반하지 않도록 관리 및 감독하고 있습니다. 회사가 개인정보처리를 위탁한 업체는 다음과 같습니다.',
    prop: {
      align: 'left',
      color: 'text_primary',
    },
  },
  {
    type: 'image',
    content: image9,
    prop: {
      shrinkPadding: true,
    },
  },
  {
    type: 'bullet',
    content:
      '② 회사는 개인정보 위탁계약시 개인정보보호 관련 법규의 준수, 개인정보에 관한 제3자 제공 금지 및 책임부담 등을 규정하고 관련 계약내용을 사내에 보관하고 있습니다. 아울러 수탁 업체가 변경될 경우 이를 공지사항 및 개인정보처리방침을 통해 고지하겠습니다.',
    prop: {
      align: 'left',
      color: 'text_primary',
    },
  },
  {
    type: 'heading3',
    content: '제7조 개인정보의 제3자 제공',
    prop: {
      align: 'left',
      color: 'text_primary',
    },
  },
  {
    type: 'bullet',
    content:
      '① 회사는 이용자의 사전 동의 없이 개인정보를 외부에 제공하지 않으며, 본 개인정보처리방침에서 명시한 목적범위 내에서만 처리합니다. 그러나 1)이용자가 제3자에 대한 개인정보 제공에 직접 사전 동의하거나 2)개인정보 보호법, 금융실명거래 및 비밀보장에 관한 법률, 신용정보의 이용 및 보호에 관한 법률, 전기통신기본법, 전기통신사업법, 지방세법, 소비자보호법, 한국은행법, 형사소송법 등 법령에 특별한 규정이 있는 경우 또는 3)고객 또는 그 법정대리인이 의사표시를 할 수 없는 상태에 있거나 주소불명 등으로 사전동의를 받을 수 없는 경우로서 명백히 고객 또는 제3자의 급박한 생명, 신체, 재산의 이익에 필요하다고 인정되는 경우 또는 4)통계작성 및 학술연구 등의 목적을 위하여 필요한 경우로서 특정 개인을 알아볼 수 없는 형태로 개인정보를 제공하는 경우에 개인정보를 제3자에게 제공할 수 있습니다.\n② 회사는 회사의 업무 수행 및 이용자에게 보다 더 나은 서비스를 제공하기 위하여 개인정보를 제휴사에 제공하거나 제휴사와 공유할 수 있습니다. 개인정보를 제휴사에 제공하거나 공유할 경우에는 사전에 이용자에게 제휴사가 어디인지, 제공 또는 공유되는 개인정보항목이 무엇인지, 왜 그러한 개인정보가 제공되거나 공유되어야 하는지, 언제까지 어떻게 보호, 관리되는지에 대해 개별적으로 고지하여 동의를 구하는 절차를 거치게 되며, 이용자께서 동의하지 않은 경우에는 제휴사에 제공하거나 제휴사와 공유하지 않습니다. 또한 이용자는 개인정보의 제공에 동의하였더라도 언제든지 그 동의를 철회할 수 있습니다.',
    prop: {
      align: 'left',
      color: 'text_primary',
    },
  },
  {
    type: 'body',
    content: '이에 따라 회사는 다음과 같이 회원의 사전 동의 하에 개인정보를 제휴사에 제공하고 있습니다.',
    prop: {
      align: 'left',
      color: 'text_primary',
    },
  },
  {
    type: 'image',
    content: image10,
    prop: {
      shrinkPadding: true,
    },
  },
  {
    type: 'bullet',
    content:
      '③ 제2항의 규정에도 불구하고 개인정보의 추가적인 이용이나 제공이 지속적으로 발생하는 경우로서 다음 각 호에 해당하는 경우에는 개인정보 보호법 제17조 제4항에 따라 이용자의 동의 없이 개인정보의 제공이 가능하며, 이 경우에는 회사는 이용자의 사전 동의 없이 이용자의 개인정보를 제휴사에 제공할 수 있습니다. \n1. 제휴사가 개인정보를 제공받아 이용하는 목적이 투자계약증권의 청약, 투자, 정산, 투자자 투표 등 회사가 제공하는 서비스의 본질적 업무를 수행하기 위하여 필요한 것으로서 개인정보를 수집한 목적과 관련성이 있을 것 \n2. 회사가 개인정보를 업무 수행 목적으로 제공한다거나 제공할 가능성이 있다는 사실을 홈페이지, 개인정보처리방침 등을 통해 이용자에게 안내하였을 것\n3. 회사와 이용자 간 체결한 계약의 이행에 필요한 것으로서 해당 개인정보를 제공하는 것이 이용자의 이익을 부당하게 침해하지 아니할 것 \n4. 암호화 등 안전성 확보에 필요한 조치를 하였을 것',
    prop: {
      align: 'left',
      color: 'text_primary',
    },
  },
  {
    type: 'body',
    content:
      '이에 따라 회사는 다음과 같이 개인정보를 제공하고 있습니다. 이에 대한 추가 또는 변경 사항이 있을 경우, 회사는 해당 사항을 홈페이지 공지사항 또는 개인정보처리방침을 통해 고지하겠습니다.',
    prop: {
      align: 'left',
      color: 'text_primary',
    },
  },
  {
    type: 'image',
    content: image11,
    prop: {
      shrinkPadding: true,
    },
  },
  {
    type: 'heading3',
    content: '제8조 정보주체의 권리 및 의무와 행사방법',
    prop: {
      align: 'left',
      color: 'text_primary',
    },
  },
  {
    type: 'bullet',
    content:
      '① 이용자는 회사에 대하여 언제든지 회사가 처리하는 자신 및 14세 미만 아동(법정대리인만 해당)에 관련한 개인정보에 대하여 다음 각 호의 권리를 행사할 수 있습니다. 단, 개인정보보호법 제35조 제4항, 제36조 제1항, 제37조 제2항 및 기타 관계 법령에 따라 제한될 수 있으며, 다른 법령에서 수집 대상으로 명시되어 있는 개인정보는 삭제, 처리 정지 요구 권한이 제한될 수 있습니다.\n1. 개인정보 열람요구\n2. 오류 등이 있을 경우 정정요구\n3. 삭제요구\n4. 처리정지 요구\n5. 관련 법령의 예외 조항 또는 의무를 준수하기 위하여 불가피한 경우\n6. 다른 사람의 신체를 해할 우려가 있거나 다른 사람의 재산을 부당하게 침해할 우려가 있는 경우\n7. 정보주체와 체결한 서비스를 제공하지 못하는 등 계약의 이행이 곤란한 경우\n② 이용자의 권리 행사는 개인정보 보호법 시행령 제41조 제1항에 따라 서면, 전자우편 등을 통하여 하실 수 있으며, 회사는 이에 대해 지체 없이 조치하겠습니다.\n③ 제1항에 따른 권리 행사는 이용자의 법정대리인이나 위임을 받은 자 등 대리인을 통하여서 하실 수 있습니다. 이 경우 개인정보보호위원회 개인정보보호지침 별지 제2호 서식에 따른 위임장을 제출하여야 합니다.',
    prop: {
      align: 'left',
      color: 'text_primary',
    },
  },
  {
    type: 'heading3',
    content: '제9조 개인정보의 파기 절차 및 방법',
    prop: {
      align: 'left',
      color: 'text_primary',
    },
  },
  {
    type: 'bullet',
    content:
      '① 회사는 원칙적으로 개인정보 처리 목적이 달성된 경우에는 보관기간 및 이용기간에 따라 해당 개인정보를 파기합니다. 이용자에게 별도의 동의를 받은 경우 또는 다른 법령에서 일정 기간 보존 의무를 부과하는 경우에는 해당 기간 동안 다른 개인정보와 분리하여 보관합니다. \n② 개인정보 파기의 절차 및 방법은 다음과 같습니다.\n1. 파기절차\n이용자가 입력한 정보는 목적 달성 후 별도의 DB에 옮겨져(종이의 경우 별도의 서류) 내부 방침 및 기타 관련법령에 따라 일정기간 저장된 후 혹은 즉시 파기됩니다. 이 때, DB로 옮겨진 개인정보는 법률에 의한 경우가 아니고서는 다른 목적으로 이용되지 않습니다.\n2. 파기방법\n전자적 파일 형태의 정보는 기록을 재생할 수 없는 기술적 방법을 사용합니다. 종이에 출력된 개인정보는 분쇄기로 분쇄하거나 소각을 통하여 파기합니다.',
    prop: {
      align: 'left',
      color: 'text_primary',
    },
  },
  {
    type: 'heading3',
    content: '제10조 개인정보의 안전한 보호 및 관리',
    prop: {
      align: 'left',
      color: 'text_primary',
    },
  },
  {
    type: 'body',
    content:
      '회사는 개인정보보호법 제29조(안전조치의 의무)에 따라 다음과 같이 안전성 확보에 필요한 기술적/관리적 및 물리적 조치를 하고 있습니다. 이용자의 개인정보는 비밀번호 및 암호화된 정보에 의해 보호되고 있습니다. 그러나 이용자의 개인정보는 공공장소에서의 인터넷사용 등 여러 방법으로 타인에게 알려질 가능성이 높으므로 이의 보호를 철저히 하는 것이 무엇보다 중요합니다. 이용자는 개인의 정보를 타인에게 유출시키거나 제공하여서는 아니되고, 자신의 개인정보를 책임 있게 관리하여야 합니다. 이러한 이용자 개인의 실수나 기본적인 인터넷의 위험성 때문에 일어나는 문제에 대해서 회사는 책임을 지지 않습니다.',
    prop: {
      align: 'left',
      color: 'text_primary',
    },
  },
  {
    type: 'bullet',
    content:
      '1. 이용자의 개인정보는 기본적으로 비밀번호 및 암호화된 정보에 의해 보호되며, 파일 및 전송 데이터를 암호화하여 중요한 데이터는 별도의 보안기능을 통해 보호되고 있습니다.\n2. 회사는 백신프로그램을 이용하여 컴퓨터 바이러스에 의한 피해를 방지하기 위한 조치를 취하고 있으며 백신프로그램은 주기적으로 업데이트 됩니다. 만일, 바이러스 침투가 될 경우 백신이 나오는 즉시 이를 제공함으로써 치료와 함께 개인정보가 침해되는 것을 방지하고 있습니다.\n3. 회사는 안전한 암호화 알고리즘을 이용하여 네트워크 상의 개인정보를 전송할 수 있는 방식을 채택하고 있습니다. \n4. 회사는 해킹 및 바이러스 등에 의하여 이용자의 개인정보가 유출되거나 훼손되는 것을 막기 위해, 보안프로그램을 설치하고 주기적인 갱신·점검을 하며 외부로부터 접근이 통제된 구역에 시스템을 설치하고 기술적/물리적으로 감시 및 차단하고 있습니다. 또한, 접속 기록의 위조, 변조를 방지하기 위해 별도의 안전한 공간에 저장하고 있습니다.\n5. 이용자의 개인정보는 암호화되어 저장 및 관리되고 있어, 본인만이 알 수 있으며 중요한 데이터는 파일 및 전송데이터를 암호화하거나 파일 잠금 기능을 사용하는 등의 별도 보안기능을 사용하고 있습니다.\n6. 회사는 이용자의 개인정보보호의 중요성을 인식하고 있으며 이를 위해 개인정보처리직원을 최소한으로 제한하고 있으며 개인정보보호책임자가 처리 직원을 대상으로 교육을 주기적으로 실시하여 개인정보보호를 위해 최선을 다하고 있습니다. 또한 본 정책에 명시된 이행사항 및 관련 직원의 준수여부를 정기적으로 점검하여 위반 내용이 있는 경우 이를 시정 또는 개선하고 기타 필요한 조치를 취하도록 하고 있습니다.',
    prop: {
      align: 'left',
      color: 'text_primary',
    },
  },
  {
    type: 'heading3',
    content: '제11조 개인정보보호책임자 등',
    prop: {
      align: 'left',
      color: 'text_primary',
    },
  },
  {
    type: 'bullet',
    content:
      '① 회사는 개인정보보호책임자를 지정하여 담당부서에서 이용자들의 소중한 개인정보보호 업무에 최선의 노력을 다하고 있습니다. 회사에 개인정보와 관련한 문의, 의견, 불만을 제기하고자 하실 경우에는 아래의 연락처나 이메일로 문의해주시기 바랍니다. 신속하고 성실하게 답변해 드리겠습니다.',
    prop: {
      align: 'left',
      color: 'text_primary',
    },
  },
  {
    type: 'image',
    content: image13,
    prop: {
      shrinkPadding: true,
    },
  },
  {
    type: 'bullet',
    content:
      '② 정보주체는 회사의 서비스를 이용하시면서 발생한 모든 개인정보 보호 관련 문의, 불만처리, 피해구제 등에 관한 사항을 개인정보 보호책임자에게 문의하실 수 있습니다. 회사는 정보주체의 문의에 대해 지체없이 답변 및 처리해드릴 것입니다.\n③ 이용자 개인정보와 관련한 보안유지책임은 해당 이용자 자신에게 있습니다. 회사는 개인 정보에 대해 어떠한 방법으로도 이용자에게 직접적으로 질문하는 경우는 없으므로 타인에게 개인 정보가 유출되지 않도록 각별히 주의하시기 바랍니다. 특히 공공장소에서 온라인상에서 접속해 있을 경우에는 더욱 유의해야 합니다.\n④ 회사가 가능한 기술적인 보완조치를 했음에도 불구하고, 첨단 기술을 이용한 해킹 등 네트워크 상의 위험에 의해 발생하는 예기치 못한 사고로 인한 정보의 훼손에 관해서는 책임이 없습니다.\n⑤ 회사는 본 개인정보 처리방침에도 불구하고 대한민국 법령에 근거하여 개인정보 제공 의무를 부담하는 경우, 법원의 명령에 따라 이를 제공할 수 있습니다.',
    prop: {
      align: 'left',
      color: 'text_primary',
    },
  },
  {
    type: 'heading3',
    content: '제12조 개인정보 상담 및 신고와 권익침해 구제방법',
    prop: {
      align: 'left',
      color: 'text_primary',
    },
  },
  {
    type: 'body',
    content:
      '개인정보침해에 관한 상담이 필요한 경우에는 개인정보침해신고센터, 대검찰청 사이버수사과, 경찰청 사이버수사국 등으로 문의하실 수 있습니다.',
    prop: {
      align: 'left',
      color: 'text_primary',
    },
  },
  {
    type: 'heading3',
    content: '개인정보 분쟁조정위원회',
    prop: {
      align: 'left',
      color: 'text_primary',
    },
  },
  {
    type: 'body',
    content: '홈페이지: https://www.kopico.go.kr\n전화번호: 1833-6972',
    prop: {
      align: 'left',
      color: 'text_primary',
    },
  },
  {
    type: 'heading3',
    content: '한국인터넷진흥원 개인정보 침해신고센터',
    prop: {
      align: 'left',
      color: 'text_primary',
    },
  },
  {
    type: 'body',
    content: '홈페이지: http://privacy.kisa.or.kr\n전화번호: 118',
    prop: {
      align: 'left',
      color: 'text_primary',
    },
  },
  {
    type: 'heading3',
    content: '대검찰청 사이버수사과',
    prop: {
      align: 'left',
      color: 'text_primary',
    },
  },
  {
    type: 'body',
    content: '홈페이지: http://www.spo.go.kr\n전화번호: 1301',
    prop: {
      align: 'left',
      color: 'text_primary',
    },
  },
  {
    type: 'heading3',
    content: '경찰청 사이버수사국',
    prop: {
      align: 'left',
      color: 'text_primary',
    },
  },
  {
    type: 'body',
    content: '홈페이지: https://ecrm.police.go.kr/minwon/main\n전화번호: 182',
    prop: {
      align: 'left',
      color: 'text_primary',
    },
  },
  {
    type: 'heading3',
    content: '제13조 개인정보 자동수집 장치의 설치와 운영 및 그 거부에 관한 사항(쿠키의 운영)',
    prop: {
      align: 'left',
      color: 'text_primary',
    },
  },
  {
    type: 'body',
    content:
      '회사는 이용자에 대한 정보를 저장하고 수시로 불러오는 쿠키(cookie)를 사용합니다. 쿠키는 웹사이트 서버가 사용자의 컴퓨터 브라우저(크롬, 마이크로소프트 엣지, 사파리, 파이어폭스 등)에게 전송하는 소량의 문자열 정보입니다. 쿠키는 이용자의 컴퓨터는 식별하지만 이용자를 개인적으로 식별하지는 않습니다. 이용자의 웹 브라우저에서 모든 쿠키를 허용하거나, 쿠키가 저장될 때마다 확인을 거치거나 모든 쿠키의 저장을 거부하는 등의 옵션을 선택하실 수 있습니다. 단, 고객이 쿠키의 저장을 거부하는 옵션을 선택하시는 경우에는 서비스 이용에 불편이 야기될 수 있습니다. 이용자는 쿠키 설치에 대한 선택권을 가지고 있으며, 언제든지 이러한 쿠키의 저장을 거부하거나 삭제할 수 있습니다.',
    prop: {
      align: 'left',
      color: 'text_primary',
    },
  },
  {
    type: 'bullet',
    content:
      '1. 쿠키의 운용\n가. 개인의 관심 분야에 따라 차별화된 정보를 제공\n나. 회원과 비회원의 접속빈도 또는 머문 시간 등을 분석하여 이용자의 취향과 관심분야를 파악하여 타겟마케팅에 활용\n다. 관심 있게 둘러본 내용들에 대한 자취를 추적하여 다음 번 접속 때 개인맞춤서비스를 제공\n라. 고객들의 습관을 분석하여 서비스 개편 등의 척도로 활용\n2. 쿠키에 대한 선택권\n이용자의 웹브라우저를 조정함으로써 모든 쿠키를 다 받아들이거나, 쿠키가 설치될 때 통지를 보내도록 하거나, 아니면 모든 쿠키를 거부할 수 있습니다. 다만 쿠키의 저장을 거부하는 경우에는 회사에서 로그인이 필요한 일부 서비스는 이용하실 수 없습니다.',
    prop: {
      align: 'left',
      color: 'text_primary',
    },
  },
  {
    type: 'body',
    content: '쿠키 설정 방법은 다음과 같습니다.',
    prop: {
      align: 'left',
      color: 'text_primary',
    },
  },
  {
    type: 'bullet',
    content:
      '가. 크롬(Chrome): https://support.google.com/chrome/answer/95647?co=GENIE.Platform%3DDesktop&hl=ko\n나. 엣지(Microsoft Edge):\nhttps://support.microsoft.com/ko-kr/microsoft-edge/microsoft-edge%EC%97%90%EC%84%9C-%EC%BF%A0%ED%82%A4-%EC%82%AD%EC%A0%9C-63947406-40ac-c3b8-57b9-2a946a29ae09\n다. 사파리(Safari)\nhttps://support.apple.com/ko-kr/guide/safari/sfri11471/mac\n라. 파이어폭스(Firefox)\nhttps://support.mozilla.org/ko/kb/clear-cookies-and-site-data-firefox?redirectslug=delete-cookies-remove-info-websites-stored&redirectlocale=ko',
    prop: {
      align: 'left',
      color: 'text_primary',
    },
  },
  {
    type: 'body',
    content: '쿠키는 브라우저의 종료시나 로그아웃시 만료됩니다.',
    prop: {
      align: 'left',
      color: 'text_primary',
    },
  },
  {
    type: 'heading3',
    content: '제14조 외부링크 사이트에 대한 책임',
    prop: {
      align: 'left',
      color: 'text_primary',
    },
  },
  {
    type: 'body',
    content:
      '회사는 이용자에게 다른 외부사이트로 연결되는 링크를 제공할 수 있습니다. 이 경우 회사는 외부사이트에 대한 통제권이 없으므로 이용자가 외부사이트로부터 제공받는 서비스나 자료의 유용성, 진실성, 적법성에 대해 책임 및 보증할 수 없으며, 링크된 외부사이트의 개인정보처리방침은 회사와 무관하므로 해당 외부사이트의 정책을 확인하시기 바랍니다.',
    prop: {
      align: 'left',
      color: 'text_primary',
    },
  },
  {
    type: 'heading3',
    content: '제15조 모바일 어플리케이션 개인정보',
    prop: {
      align: 'left',
      color: 'text_primary',
    },
  },
  {
    type: 'bullet',
    content:
      '① 회사는 모바일 어플리케이션 서비스를 운영, 제공하기 위하여 아래 정보를 생성, 수집, 이용하고 저장할 수 있습니다.\n② 스마트폰 등 모바일 앱을 통해 서비스를 이용할 경우 이용자에게 개인정보 수집, 이용에 대한 동의를 받고, 고지한 범위 내에서 정보를 수집하고 이용합니다. \n1. 단말기 로그인 데이터\n2. 위치 정보\n3. 단말기 ID, 모델, OS, 브라우저 종류\n4. 사진, 미디어, 파일 등의 정보\n5. 그 외 추가 수집에 대하여 동의 받은 정보\n③ 이용자는 언제든지 이용자 설정에 접근하고 변경할 수 있으며, 단말기 옵션, 설정 메뉴로부터 이용자의 이력을 삭제할 수 있습니다. 단, 단말기에서 앱을 삭제하더라도 이용자의 회원 계정은 삭제되지 않으므로, 더 이상의 이용을 원치 않을 경우 먼저 탈퇴 후 앱을 삭제해주시면 됩니다.',
    prop: {
      align: 'left',
      color: 'text_primary',
    },
  },
  {
    type: 'heading3',
    content: '제16조 고지의무',
    prop: {
      align: 'left',
      color: 'text_primary',
    },
  },
  {
    type: 'body',
    content:
      '본 개인정보처리방침은 시행일로부터 적용되며, 법령 및 방침에 따른 변경 내용의 추가, 삭제 및 정정이 있는 경우 회사는 홈페이지를 통해 즉시 변경된 개인정보처리방침을 공고한 후 공고한 날로부터 시행하되, 별도의 시행 일자를 정한 경우에는 해당 시행 일자에 시행합니다.',
    prop: {
      align: 'left',
      color: 'text_primary',
    },
  },
  {
    type: 'body',
    content: '부칙\n제1조 (시행 일자)\n본 개인정보처리방침은 2024년 9월 9일부터 시행합니다.',
    prop: {
      align: 'left',
      color: 'text_primary',
    },
  },
]

export function Privacy() {
  return (
    <Wrap>
      <StyledContent>
        <ArtipioContents>
          {TERMS_DATA.map((content, i) => {
            const isFirstImg = content.type === 'image' && i === 0
            const isLastImg = content.type === 'image' && i === TERMS_DATA.length - 1
            return <ArtipioContentItem key={i} {...content} isFirstImg={isFirstImg} isLastImg={isLastImg} />
          })}
        </ArtipioContents>
      </StyledContent>
    </Wrap>
  )
}

const StyledContent = styled(Content)`
  padding-bottom: 108px;
`
